import ClipboardJS from "clipboard/dist/clipboard.min.js";
import Toastify from 'toastify-js';
import { log } from "../utils/logger";
function tostifyCustomClose(el) {
  const parent = el.closest('.toastify');
  const close = parent.querySelector('.toast-close');

  close.click();
}
window.tostifyCustomClose = tostifyCustomClose

window.addEventListener("turbo:load", () => {
  var elements = Array.from(document.getElementsByClassName("js-copy-button"))
  elements.forEach((element) => {
    const copyButton = new ClipboardJS(element)
    copyButton.on("success", () => {
      const markup = `
        <div class="flex p-4">
          <p class="text-sm text-gray-700 dark:text-neutral-400">Copied!</p>
          <div class="ms-auto">
            <button onclick="tostifyCustomClose(this)" type="button" class="inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white" aria-label="Close">
              <span class="sr-only">Copied!</span>
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
            </button>
          </div>
        </div>
      `;
      Toastify({
        text: markup,
        duration: 3000,
        gravity: "top", // `top` or `bottom`
        position: "left", // `left`, `center` or `right`
        className: "hs-toastify-on:opacity-100 opacity-0 fixed -top-[150px] right-[20px] z-[90] transition-all duration-300 w-[320px] bg-white text-sm text-gray-700 border border-gray-200 rounded-xl shadow-lg [&>.toast-close]:hidden dark:bg-neutral-800 dark:border-neutral-700 dark:text-neutral-400",
        close: true,
        escapeMarkup: false,
      }).showToast();
    })
    log("copy button", element, copyButton)
  })
})
